import React from "react";
import styled from "styled-components";

const Container = styled.main`
  width: 80%;
  margin: 0 auto;
  padding-top: 15rem;
  padding-bottom: 15rem;
  @media (max-width: 1023px) {
    padding-top: 9rem;
  }
  @media (max-width: 767px) {
    width: auto;
    margin-left: 3rem;
    margin-right: 3rem;
  }
  @media (max-width: 480px) {
    padding-top: 7.5rem;
  }
`;

export default ({ children, ...rest }) => {
  return <Container {...rest}>{children}</Container>;
};
